/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  StoryCard,
  StoryCardArticleContent,
  StoryCardAudioContent,
  StoryCardEditorialContent,
  StoryCardEventContent,
  StoryCardImageContent,
  StoryCardPdfContent,
  StoryCardPollContent,
  StoryCardQuoteContent,
  StoryCardType,
  StoryCardVideoContent,
} from '../../services';
import {
  FullPostFields,
  LinkPostFields,
  PollPostFields,
  ShortPostFields,
  ThreadPostFields,
} from '../components';

export const getPostFieldsFromCard = (card?: StoryCard) => {
  if (!card) {
    return;
  }

  const { type, content, event } = card;

  switch (type) {
    case StoryCardType.THREAD:
      return { threadPostFilledFields: content as ThreadPostFields };
    case StoryCardType.POST: {
      return { fullPostFilledFields: content as FullPostFields };
    }
    case StoryCardType.EDITORIAL: {
      const { textHTML = '', ...postContent } = content as StoryCardEditorialContent;

      return { shortPostFilledFields: { ...postContent, gallery: [] } as ShortPostFields };
    }
    case StoryCardType.IMAGE:
    case StoryCardType.AUDIO:
    case StoryCardType.VIDEO:
    case StoryCardType.PDF: {
      const { textHTML = '', ...postContent } = content as
        | StoryCardImageContent
        | StoryCardAudioContent
        | StoryCardVideoContent
        | StoryCardPdfContent;

      return { shortPostFilledFields: postContent as ShortPostFields };
    }
    case StoryCardType.ARTICLE: {
      const { url, ...postContent } = content as StoryCardArticleContent;

      return {
        linkPostFilledFields: { url, type, article: { ...postContent, type } } as LinkPostFields,
      };
    }
    case StoryCardType.QUOTE: {
      const { url, ...postContent } = content as StoryCardQuoteContent;

      return {
        linkPostFilledFields: { url, type, quote: { ...postContent, type } } as LinkPostFields,
      };
    }
    case StoryCardType.POLL: {
      const { selectedVoteIds, voteResults, ...postContent } = content as StoryCardPollContent;

      return { pollPostFilledFields: postContent as PollPostFields };
    }
    case StoryCardType.EVENT: {
      const { headline } = content as StoryCardEventContent;

      return { eventPostFilledFields: { event, headline } };
    }
  }
};
